import { ReactNode } from 'react'

import { type LazyToggleMethod, Tooltip } from '@factorialco/deprecated-design-system'
import { TrainingsTrainingMembershipStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const AttendanceTooltip = ({
  open,
  status,
  children,
  toggle,
}: {
  open: boolean
  status: TrainingsTrainingMembershipStatusEnum
  children: ReactNode
  toggle: LazyToggleMethod
}) => {
  const label = () => {
    switch (status) {
      case 'completed':
        return i18n.t('trainings.trainings_revamp.classes.attendance_tooltips.completed')
      case 'missing':
        return i18n.t('trainings.trainings_revamp.classes.attendance_tooltips.missing')
      case 'notstarted':
        return i18n.t('trainings.trainings_revamp.classes.attendance_tooltips.notstarted')
      default:
      case 'notassigned':
        return i18n.t('trainings.trainings_revamp.classes.attendance_tooltips.notassigned')
      case 'partiallycompleted':
        return i18n.t('trainings.trainings_revamp.classes.attendance_tooltips.partiallycompleted')
      case 'started':
        return i18n.t('trainings.trainings_revamp.classes.attendance_tooltips.started')
    }
  }
  return (
    <Tooltip.Alt attachment="bottom left" open={open} label={label()} toggle={toggle}>
      {children}
    </Tooltip.Alt>
  )
}
